import { render, staticRenderFns } from "./BranchJP.vue?vue&type=template&id=5974767e&scoped=true&"
import script from "./BranchJP.vue?vue&type=script&lang=js&"
export * from "./BranchJP.vue?vue&type=script&lang=js&"
import style0 from "./BranchJP.vue?vue&type=style&index=0&id=5974767e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974767e",
  null
  
)

export default component.exports